import { ReactNode } from "react";
import { classNames } from "primereact/utils";
import styles from "./PhoneScreen.module.scss";

interface IPhoneScreenProps {
  className?: string;
  children: ReactNode;
}

/** A phone screen to preview a message on: the SMS conversation, the notification on the lock screen. */
export const PhoneScreen = ({ className, children }: IPhoneScreenProps) => (
  <div className={classNames(styles.root, className)}>{children}</div>
);
